var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_680_5700)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5416 6C15.4676 6 15.3966 6.0294 15.3442 6.08174C15.2919 6.13407 15.2625 6.20506 15.2625 6.27907C15.2625 6.35308 15.2919 6.42407 15.3442 6.4764C15.3966 6.52874 15.4676 6.55814 15.5416 6.55814H17.0471L14.9187 8.68651C14.8679 8.73917 14.8398 8.80968 14.8405 8.88285C14.8411 8.95602 14.8705 9.026 14.9223 9.07772C14.974 9.12943 15.0441 9.15875 15.1172 9.15935C15.1904 9.15995 15.2609 9.13179 15.3135 9.08093L17.4419 6.95256V8.45842C17.4419 8.53243 17.4713 8.60342 17.5236 8.65575C17.5759 8.70809 17.6469 8.73749 17.7209 8.73749C17.7949 8.73749 17.8659 8.70809 17.9183 8.65575C17.9706 8.60342 18 8.53243 18 8.45842V6.27907C18 6.20506 17.9706 6.13407 17.9183 6.08174C17.8659 6.0294 17.7949 6 17.7209 6H15.5416ZM12.4584 14C12.5324 14 12.6034 13.9706 12.6558 13.9183C12.7081 13.8659 12.7375 13.7949 12.7375 13.7209C12.7375 13.6469 12.7081 13.5759 12.6558 13.5236C12.6034 13.4713 12.5324 13.4419 12.4584 13.4419H10.9529L13.0813 11.3135C13.1079 11.2877 13.1292 11.2569 13.1438 11.2229C13.1584 11.1888 13.1661 11.1522 13.1664 11.1151C13.1667 11.0781 13.1596 11.0413 13.1456 11.0071C13.1315 10.9728 13.1108 10.9416 13.0846 10.9154C13.0584 10.8892 13.0272 10.8685 12.9929 10.8545C12.9586 10.8405 12.9218 10.8335 12.8848 10.8338C12.8477 10.8341 12.8111 10.8418 12.7771 10.8565C12.743 10.8711 12.7122 10.8924 12.6865 10.9191L10.5581 13.0474V11.5416C10.5581 11.5049 10.5509 11.4686 10.5369 11.4348C10.5229 11.4009 10.5023 11.3702 10.4764 11.3442C10.4505 11.3183 10.4197 11.2978 10.3859 11.2838C10.352 11.2697 10.3157 11.2625 10.2791 11.2625C10.2424 11.2625 10.2061 11.2697 10.1723 11.2838C10.1384 11.2978 10.1077 11.3183 10.0817 11.3442C10.0558 11.3702 10.0353 11.4009 10.0212 11.4348C10.0072 11.4686 10 11.5049 10 11.5416V13.7209C10 13.875 10.125 14 10.2791 14H12.4584Z",
    fill: "#1D242D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_680_5700",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_680_5700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_680_5700",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveFullscreen);
export default __webpack_public_path__ + "static/media/live-fullscreen.e1d046ca85e6cc52920c26be1ae13d1b.svg";
export { ForwardRef as ReactComponent };